import React, { useEffect, useState } from 'react';
import { Modal } from 'semantic-ui-react';
import { useQuery } from '@tanstack/react-query';
import { Banner, BannerLocationActivationEnum } from '../../types/Banner';
import { getBannersPopup } from '../../services/banner';

interface PopupModalInterface {
  locationActivation: BannerLocationActivationEnum;
}

const PopupModal = ({ locationActivation }: PopupModalInterface) => {
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const today = new Date().toISOString().split('T')[0];

  const STORAGE_KEY = `popup_banners_last_seen_${locationActivation}`;

  const shouldOpenToday = () => {
    const lastSeen = localStorage.getItem(STORAGE_KEY);
    return lastSeen !== today;
  };

  const markAsSeenToday = () => {
    localStorage.setItem(STORAGE_KEY, today);
  };

  // TanStack Query
  const { data: banners = [] } = useQuery<Banner[]>({
    queryKey: ['popup-banners', locationActivation],
    queryFn: () => getBannersPopup(locationActivation),
    staleTime: 1000 * 60 * 60 * 24, // 24 horas
    cacheTime: 1000 * 60 * 60 * 24, // mantém no cache por 24h
    refetchOnWindowFocus: false
  });

  useEffect(() => {
    if (banners.length && shouldOpenToday()) {
      setOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [banners]);

  const onClose = () => {
    // Se ainda existir banner na fila abre o próximo
    if (currentIndex < banners.length - 1) {
      setCurrentIndex(prev => prev + 1);
    } else {
      // Terminou todos marca como exibido hoje
      markAsSeenToday();
      setOpen(false);
    }
  };

  if (!banners.length) return null;

  const currentBanner = banners[currentIndex];

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="small"
      closeOnEscape
      closeOnTriggerClick
      closeOnDocumentClick={false}
      closeOnDimmerClick
      style={{ width: '500px', height: '705px', padding: '0', borderRadius: '8px' }}
      closeIcon
    >
      <Modal.Content
        style={{ width: '500px', height: '705px', padding: '0', borderRadius: '8px' }}
      >
        <img
          src={currentBanner.imageUrl}
          style={{ width: '500px', height: '705px' }}
          alt="banner-popup"
        />
      </Modal.Content>
    </Modal>
  );
};

export default PopupModal;
